import React, { useState } from 'react';
import LetterIcon from "../../UI/LetterIcon/LetterIcon";
import Button from "../../UI/Button/Button";
import classes from "./CreatePost.css";


const CreatePost = (props) => {
    const [state, setState] = useState({
        title: "",
        content: ""
    })
    return (
        <div className={classes.CreatePost}>
            <div className={classes.Header}>
                <LetterIcon letter="Me" color="#27ae60" />
                <span>Write a post </span>
            </div>
            <div className={classes.Content}>
                <input type="text" placeholder="title" onChange={(event) => setState({ ...state, title: event.target.value })} />
                <textarea placeholder="What do you think ?" onChange={(event) => setState({ ...state, content: event.target.value })} />
            </div>
            <div className={classes.Footer}>
                <Button success onClicked={() => props.createPost(state)}> Share the post </Button>
            </div>

        </div>
    );
}

export default CreatePost;